import { FamilyMember } from '../types';
import { INITIAL_FAMILY } from '../data/mockState';

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
const FAMILY_STORAGE_KEY = 'idfraud_family_members';

function getStoredFamily(): FamilyMember[] {
  const raw = localStorage.getItem(FAMILY_STORAGE_KEY);
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch {
      return INITIAL_FAMILY;
    }
  }
  localStorage.setItem(FAMILY_STORAGE_KEY, JSON.stringify(INITIAL_FAMILY));
  return INITIAL_FAMILY;
}

export async function getFamilyMembers(): Promise<FamilyMember[]> {
  await delay(300);
  return getStoredFamily();
}

export async function addFamilyMember(member: {
  relationship: FamilyMember['relationship'];
  name: string;
  email: string;
  phone?: string;
}): Promise<FamilyMember> {
  await delay(400);
  const current = getStoredFamily();
  const colors = ['bg-emerald-600', 'bg-blue-600', 'bg-purple-600', 'bg-amber-600', 'bg-rose-600'];
  const newMember: FamilyMember = {
    id: 'fam-' + Math.random().toString(36).substring(2, 6),
    relationship: member.relationship,
    name: member.name,
    email: member.email,
    phone: member.phone,
    securityScore: 85,
    activeAlertsCount: 0,
    monitoringStatus: 'active',
    consentGranted: true,
    avatarColor: colors[current.length % colors.length]
  };
  const updated = [...current, newMember];
  localStorage.setItem(FAMILY_STORAGE_KEY, JSON.stringify(updated));
  return newMember;
}

export async function removeFamilyMember(id: string): Promise<FamilyMember[]> {
  await delay(300);
  const current = getStoredFamily();
  const updated = current.filter(m => m.id !== id);
  localStorage.setItem(FAMILY_STORAGE_KEY, JSON.stringify(updated));
  return updated;
}
